import { useSearch } from "@tanstack/react-router";
import { ConsultationPaymentSuccessCard } from "~/features/appointments/components/consultation-payment-card";

export function ConfirmationPage() {
  const { consultation_encounter_id } = useSearch({ from: "/(public)/_public/consultations/confirmation" })

  return (
    <ConsultationPaymentSuccessCard consultation_id={consultation_encounter_id ?? ""} />
  );
}
